import '../../styles/_tooltip-rich.scss';

import React, { PropsWithChildren, useState } from 'react';

export interface ITooltipRichLink {
    text: string;
    href: string;
}

export interface ITooltipRichProps extends PropsWithChildren {
    alignment?: 'left' | 'right';
    title?: string | null;
    copy?: string | null;
    link?: ITooltipRichLink | null;
    backgroundColor?: string;
    textColor?: string;
    width?: number | string;
    height?: number | string;
}

const toSize = (value: number | string | undefined) => (typeof value === 'number' ? `${value}px` : value);

export const TooltipRich = (props: ITooltipRichProps) => {
    const {
        alignment,
        title,
        copy,
        link,
        backgroundColor,
        textColor,
        width,
        height,
        children
    } = props;
    const [showTooltip, setShowTooltip] = useState(false);

    const alignmentClass = alignment === 'left' ? 'rich-tooltip--left' : alignment === 'right' ? 'rich-tooltip--right' : 'rich-tooltip--center';

    const tooltipStyle: React.CSSProperties = {
        ...(backgroundColor ? { background: backgroundColor } : {}),
        ...(textColor ? { color: textColor } : {}),
        ...(width !== undefined ? { width: toSize(width), maxWidth: toSize(width) } : {}),
        ...(height !== undefined ? { height: toSize(height) } : {}),
        ...(width !== undefined || height !== undefined ? { boxSizing: 'border-box' } : {}),
    };
    const linkStyle = textColor ? { color: textColor } : undefined;

    return (
        <div
            className='rich-tooltip__wrapper'
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onFocus={() => setShowTooltip(true)}
            onBlur={() => setShowTooltip(false)}
        >
            {children}
            {showTooltip && (
                <div role='tooltip' className={`rich-tooltip paragraph-2 ${alignmentClass}`} style={tooltipStyle}>
                    {title && <span className='rich-tooltip__title'>{title}</span>}
                    {copy && <span className='rich-tooltip__copy'>{copy}</span>}
                    {link?.href && (
                        <a
                            className='rich-tooltip__link'
                            style={linkStyle}
                            href={link.href}
                            target='_blank'
                            rel='noopener noreferrer'
                        >{link.text || link.href}</a>
                    )}
                </div>
            )}
        </div>
    );
};

export default TooltipRich;
